import { ref, req, withParams } from "vuelidate/lib/validators/common";

/// WARNING: Although Vuelidate works correctly with these validator,
///          Vuetify does not. The error message will not update if the validator
///          passes due to the otherProperty changing. To get around this you need
///          to add a "ref" attribute on the otherProperty and when the value changes
///          re-validate the field being validated.
///          See promoCode or campaignDetails for examples...

export function numberGreaterThan(otherProperty: any) {
  return withParams({ type: "numberGreaterThan", gt: otherProperty }, function(
    value: any,
    parentVm: any
  ) {
    // Check if a value has been passed in
    if (!req(value)) {
      return true;
    }

    // Skip non numbers. Let the other validators handle this.
    if (isNaN(value)) {
      return true;
    }

    // Check if the other property has a value
    const otherValue = ref(otherProperty, this, parentVm);
    if (!req(otherValue)) {
      return true;
    }

    return Number(value) > Number(otherValue);
  });
}

export function dateGreaterThan(otherProperty: any) {
  return withParams({ type: "dateGreaterThan", gt: otherProperty }, function(
    value: any,
    parentVm: any
  ) {
    // Check if a value has been passed in
    if (!req(value)) {
      return true;
    }

    // Let the other validators handle proper type validation.
    if (isNaN(Date.parse(value))) {
      return true;
    }

    // Check if the other property has a value
    const otherValue = ref(otherProperty, this, parentVm);
    if (!req(otherValue)) {
      return true;
    }

    return new Date(value) > new Date(otherValue);
  });
}
